import Decimal from "decimal.js";
import { CustomAttribute } from "types";
import { formatISODate } from "utils/helpers";

export const convertCustomAttributesToArray = (
  customAttributeValues: Record<string, string | undefined>,
  customAttributes: CustomAttribute[],
  convertToBaseCurrencyDecimal: (
    value: string | number | Decimal,
  ) => Decimal | null,
): { name: string; value: string }[] => {
  return Object.entries(customAttributeValues).reduce(
    (acc, [name, value]) => {
      const attribute = customAttributes.find((attr) => attr.name === name);
      if (attribute?.type === "decimal" && value !== undefined) {
        const convertedValue = convertToBaseCurrencyDecimal(value);
        if (convertedValue === null) {
          return acc;
        }
        value = convertedValue.toString();
      }
      if (attribute?.type === "date") {
        value =
          value && !isNaN(Date.parse(value))
            ? (formatISODate(value) ?? undefined)
            : undefined;
        if (!value) {
          return acc;
        }
      }
      acc.push({
        name,
        value: value as string,
      });
      return acc;
    },
    [] as { name: string; value: string }[],
  );
};
